module.exports = __webpack_public_path__ + "d83d8f28fd258391dd38486ca196f927.png";